import axios from 'axios';

const api = axios.create({ baseURL: process.env.VUE_APP_API_URL || '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('aprocon_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.error || 'Ein Fehler ist aufgetreten.';
    return Promise.reject(new Error(message));
  }
);

export default api;
